import React from "react";
import { CheckCircle, ArrowRight, Sparkles } from "lucide-react";

type Pass = {
  id: string;
  name: string;
  price: string;
  features: string[];
  link?: string; // ✅ optional, NOT null
  disabled?: boolean;
};

const PassesPage = () => {
  const standardPasses: Pass[] = [
    {
      id: "pass10",
      name: "Paper Presentation",
      price: "₹99",
      features: ["Paper Presentation", "Certificates"],
      disabled: true,
    },
    {
      id: "pass9",
      name: "IPL AUCTION",
      price: "₹299",
      features: ["IPL AUCTION EVENT ONLY"],
      disabled: true,
    },
    {
      id: "pass7",
      name: "Seminar",
      price: "₹99",
      features: ["1 Seminar", "Certificates"],
      disabled: true,
    },
    {
      id: "pass1",
      name: "Non-Tech Only",
      price: "₹149",
      features: [
        "Escape Room",
        "True Detective",
        "Anime Quiz",
        "Squid Game",
        "Movies Mania",
        "Series Quiz",
        "Connexion",
        "Networking",
        "Cash Prize & Vouchers",
      ],
      disabled: true,
    },
    {
      id: "pass2",
      name: "Tech Only",
      price: "₹199",
      features: [
        "Relay Coding",
        "Code Golf",
        "Logic Coding",
        "TIK TIK TIK",
        "Blind Coding",
        "Technical Quiz",
        "Code Hunt",
        "Prompt Master",
        "Networking",
        "Cash Prize & Vouchers",
      ],
      disabled: true,
    },
    {
      id: "pass3",
      name: "Tech + Non-Tech",
      price: "₹249",
      features: ["Tech Pass", "Non Tech Pass", "Networking", "Cash Prize"],
      disabled: true,
    },
    {
      id: "pass4",
      name: "Golden Byte + Non-Tech",
      price: "₹249",
      features: [
        "Rapid Coding",
        "Treasure Hunt",
        "Non-Tech Pass",
        "Cash Prize",
        "Gold Coins",
      ],
      disabled: true, // ✅ no link at all
    },
    {
      id: "pass5",
      name: "All Access",
      price: "₹349",
      features: [
        "Tech Pass",
        "Non Tech Pass",
        "Golden Byte",
        "Cash Prize & Gold Coin & Vouchers",
        "Exclusive of Seminar Pack, IPL Auction, Online Games, Paper Presentation",
      ],
      disabled: true,
    },
    {
      id: "pass6",
      name: "Seminar Package",
      price: "₹299",
      features: ["1 Webinar", "1 Seminar", "1 Workshop"],
      disabled: true, // ✅ no link at all
    },
    {
      id: "pass8",
      name: "Workshop",
      price: "₹99",
      features: [],
      disabled: true, // ✅ no link at all
    },
    {
      id: "pass11",
      name: "Webinar",
      price: "₹99",
      features: [],
      disabled: true, // ✅ no link at all
    },
  ];

  return (
    <div className="min-h-screen bg-black py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <Sparkles className="w-12 h-12 text-red-600 mx-auto mb-4" />
          <h1 className="text-5xl font-bold text-red-600">STANDARD PASSES</h1>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {standardPasses.map((pass) => (
            <div
              key={pass.id}
              className={`relative rounded-2xl p-6 flex flex-col border bg-black ${
                pass.disabled
                  ? "border-red-900 opacity-70"
                  : "border-red-600 hover:shadow-xl hover:shadow-red-600/30"
              }`}
            >
              {!pass.disabled && (
                <div className="absolute -top-3 -right-3 px-4 py-2 bg-red-700 text-white font-bold rounded-xl">
                  {pass.price}
                </div>
              )}

              <h3 className="text-xl font-bold text-red-500 mt-6 mb-4">
                {pass.name}
              </h3>

              {!pass.disabled && (
                <ul className="space-y-3 flex-1 mb-6">
                  {pass.features.map((feature, idx) => (
                    <li key={idx} className="flex gap-3">
                      <CheckCircle className="w-5 h-5 text-red-600" />
                      <span className="text-red-400 text-sm">{feature}</span>
                    </li>
                  ))}
                </ul>
              )}

              {pass.disabled ? (
                <div className="mt-auto py-3 text-center text-red-700 font-semibold border border-red-800 rounded-xl cursor-not-allowed">
                  On-Spot Registrations Available
                </div>
              ) : (
                <a
                  href={pass.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-auto py-3 bg-red-700 hover:bg-red-600 text-white text-center font-semibold rounded-xl transition"
                >
                  <span className="flex items-center justify-center gap-2">
                    Register Now <ArrowRight className="w-4 h-4" />
                  </span>
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PassesPage;
